import type { svgPlaceType } from '../../types'
import { BingoDark, BingoWhite, PulszDark, PulszWhite } from '../icons'

const iconsByTheme = ((brandName) =>
  brandName === 'pulsz' ? { dark: PulszDark, white: PulszWhite } : { dark: BingoDark, white: BingoWhite })(
  process.env.BRAND_NAME,
)

type Props = {
  isDarkMode: boolean
} & svgPlaceType

export default function LogoIcon({ isDarkMode, ...props }: Props) {
  const Icon = iconsByTheme[isDarkMode ? 'dark' : 'white']

  return <Icon {...props} />
}
